export default __webpack_public_path__ + "static/media/gallery 6.67bc45be.png";